var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IConfigurationRepositoryType } from '../../../Domain/UseCases/Configuration/IConfigurationRepository';
import { Observable } from '../../Observable/Observable';
import { EventBus } from '../../EventBus/EventBus';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
let ThemeRepository = class ThemeRepository {
    constructor(configurationRepository) {
        this.configurationRepository = configurationRepository;
        this.themeEventBus = new EventBus();
        this.componentThemeEventBus = new EventBus();
        this.transparentHeader = new Observable(false);
        this.configurationRepository.configuration.observe(this, configuration => {
            var _a, _b;
            const headerTransparent = !!((_b = (_a = configuration.application) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.transparent_header);
            headerTransparent !== this.transparentHeader.value && this.transparentHeader.next(headerTransparent);
            Object.entries(configuration).forEach(([moduleName, moduleConfiguration]) => {
                moduleConfiguration && typeof moduleConfiguration === 'object' && this.themeEventBus.next(moduleName, moduleConfiguration.theme);
            });
        });
    }
    getTransparentHeader() {
        return this.transparentHeader;
    }
    getComponentThemeName(moduleName, componentName) {
        return `${moduleName}:${componentName}`;
    }
    getTheme(moduleName = 'application') {
        const themeObservable = this.themeEventBus.get(moduleName);
        if (!themeObservable.value) {
            themeObservable.next({});
        }
        return themeObservable;
    }
    getComponentTheme(moduleName, componentName) {
        var _a, _b;
        const componentThemeObservable = this.componentThemeEventBus.get(this.getComponentThemeName(moduleName, componentName));
        if (!componentThemeObservable.value) {
            const moduleStyles = this.getTheme(moduleName);
            componentThemeObservable.next(((_b = (_a = moduleStyles.value) === null || _a === void 0 ? void 0 : _a.layouts) === null || _b === void 0 ? void 0 : _b[componentName]) || {});
            moduleStyles.observe(this, value => {
                var _a;
                componentThemeObservable.next(((_a = value === null || value === void 0 ? void 0 : value.layouts) === null || _a === void 0 ? void 0 : _a[componentName]) || {});
            });
            return componentThemeObservable;
        }
        return componentThemeObservable;
    }
};
ThemeRepository = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IConfigurationRepositoryType)),
    __metadata("design:paramtypes", [Object])
], ThemeRepository);
export { ThemeRepository };
